import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadioSelected = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1.5,
		y: 1.5,
		width: 17,
		height: 17,
		rx: 4.5,
		stroke: "currentColor"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 4.5,
		y: 4.5,
		width: 11,
		height: 11,
		rx: 3,
		fill: "currentColor"
	})]
});
export default SvgRadioSelected;
